<template>
  <rt-section :title="title" icon="rt-base-account">
    <div slot="btn">
      <rt-search v-model="queryValue" :more="false" @on-search="search" />
    </div>
    <rt-table
      ref="table"
      :fetch="fetchData"
      :auto-height="false"
      :page-size="10"
      :class="{ 'is-single': !multiple }"
      :total-record="total"
      :row-key="getRowKeys"
      :height="computedHeight"
      page-layout="total, prev, pager, next"
      class="rt-table-aside"
      @select="select"
      @select-all="selectAll"
    >
      <rt-table-column
        v-for="(item, index) in displayFields"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      />
    </rt-table>
  </rt-section>
</template>
<script>
const copyObj = obj => (obj ? JSON.parse(JSON.stringify(obj)) : '');

import RtSection from '../section/rtSection';
import RtSearch from '../search/rtSearch';
import RtTable from '../table/rtTable';
import RtTableColumn from '../table/rtTableColumn.js';

export default {
  name: 'RtNewLookupView',
  components: {
    RtSection,
    RtSearch,
    RtTable,
    RtTableColumn
  },
  props: {
    fetch: {
      type: Function,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    displayFields: {
      type: Array,
      default() {
        return [];
      }
    },
    title: String,
    total: Number
  },
  data() {
    return {
      queryValue: '',
      computedHeight: 300
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.computedHeight = 0;
      let computedHeight = document.querySelector(
        '.rt-dialog-wrapper .el-dialog__body'
      ).clientHeight;
      this.computedHeight = computedHeight - 60 - 56;
    });
  },
  methods: {
    getRowKeys(row) {
      return row.Value;
    },
    search() {
      this.lodaData();
    },
    // 加载数据
    lodaData() {
      this.$refs.table.clearSelection();
      this.$refs.table.loadData();
    },
    fetchData({ pageIndex, pageSize }) {
      let params = {
        pageIndex,
        pageSize,
        queryValue: this.queryValue
      };
      return this.fetch(params);
    },
    select(selection, row) {
      if (this.multiple) {
        this.$emit('change', {
          data: copyObj(selection),
          multiple: true
        });
      } else {
        let selected = selection[0];
        // 判断 selection 是否有已经选中项目
        if (selected !== row) {
          this.$refs.table.toggleRowSelection(selected);
          selected = row;
        }
        this.$emit('change', {
          data: copyObj(selected),
          multiple: false
        });
      }
    },
    selectAll(selection) {
      this.$emit('change', {
        data: copyObj(selection),
        multiple: true
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLookupView.vue?b804ee3a